/**
 * Purchase panel restructuring — per Westman Atelier reference (Emily's
 * direct spec, Aug 16 2026 build session). Structural, not spatial: merges
 * the price into the Add to Cart button and tightens the pack/quantity pair
 * into one visual unit. Implemented as DOM moves + scoped CSS rather than
 * editing buy-buttons.liquid or variant-picker.liquid, since both are shared
 * across every product on the site, not just the Cuticle Pen.
 */

function mergePriceIntoAddToCart() {
  const scope = document.querySelector('.shopify-section--main-product');
  if (!scope) return;

  const button = scope.querySelector('buy-buttons .button[type="submit"]');
  const priceList = scope.querySelector('price-list');
  if (!button || !priceList) return;
  if (button.contains(priceList)) return; // already merged

  // The button's existing content is a bare text node ("Add to Cart") — wrap
  // it so flexbox can separate the label from the price we're about to add.
  const label = document.createElement('span');
  label.className = 'button__label';
  while (button.firstChild) {
    label.appendChild(button.firstChild);
  }
  button.appendChild(label);

  priceList.classList.add('button__price');
  button.appendChild(priceList);
  button.classList.add('button--with-price');

  // The price's original slot in the block list is now empty — collapse it
  // rather than leaving a blank gap where the price used to render.
  const originalSlot = scope.querySelector('.product-info__block-item[data-block-type="price"]');
  if (originalSlot) originalSlot.style.display = 'none';
}

// Prestige swaps parts of the purchase panel's HTML on variant change (via
// <product-rerender>), which would silently undo the DOM move above. Re-run
// on the events that accompany that, plus a MutationObserver as a catch-all.
document.addEventListener('DOMContentLoaded', mergePriceIntoAddToCart);
document.addEventListener('variant:change', mergePriceIntoAddToCart);

const panel = document.querySelector('.shopify-section--main-product .product-info__block-list');
if (panel) {
  new MutationObserver(mergePriceIntoAddToCart).observe(panel, { childList: true, subtree: true });
}
